/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// styles
// import injectSheet from 'react-jss';
// import styles from 'material/structure/page/page_styles';



/* ========== ~~~~~~~~~~ PAGE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class Page extends Component {
	constructor(props) {
		super(props);
		this.state = { phase: 'loading' };
	}
	componentDidMount() {
		setTimeout(() => {
			this.setState({ phase: 'loaded' });
		}, 100)
	}
	render() {
	    return(
	    	<div id={this.props.name} className={`page ${this.state.phase} ${this.props.klass ? this.props.klass : ''}`}>
	    		{this.props.children}
	        </div>
	    );
	}
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default Page;
// export default injectSheet(styles)(Page);
